import { currentDevelopmentUIState } from './dev-ui-state';
import { isOfflineMode } from './is-dev-mode';

export const getBoardIdForLocalDevelopment = () => {
  if (isOfflineMode()) {
    // There's no such thing as a real "board" in offline mode so we have to
    // make one up
    return '67cf0f6d-d456-4a0c-94f6-1ecc75b04506';
  } else {
    return currentDevelopmentUIState.boardId;
  }
};
